import { NgModule } from '@angular/core';
import { ImprintComponent } from './imprint.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [ImprintComponent],
  imports: [MatTooltipModule],
  exports: [ImprintComponent]
})
export class ImprintModule {
}
